exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@special-offer : ~'.special-offer';\n.special-offer--even .special-offer__right[data-v-0ecb5078] {\n  background-color: #000000;\n}\n.special-offer--odd .special-offer__right[data-v-0ecb5078] {\n  background-color: #121212;\n}\n", ""]);

// exports
